import { Button } from 'antd';

export default function SubmitBtn({
    label,
    className,
    isLoading,
    onClick,
    disabled,
    icon: Icon,
}) {
    return (
        <Button
            type="primary"
            onClick={onClick}
            loading={isLoading}
            disabled={disabled}
            htmlType="submit"
            block
            className={`w-full h-[40px] px-[8px] py-[6px] font-favorit font-[500] text-[14px] leading-[16px] rounded-[54px] bg-theme-orange hover:bg-theme-orange-hover submit-btn ${className}`}>
            {Icon && <Icon className="text-2xl" />}
            {label}
        </Button>
    );
}
